import { Box, Typography } from "@mui/material";
import LandingSectionLayout from "./LandingSectionLayout";
import mainBackgroundImg from "../../content/images/main-background-image.jpg";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import { ScheduleNowButton } from "../atoms/ScheduleNowButton";

export default function LandingSection() {
  return (
    <LandingSectionLayout
      sxBackground={{
        backgroundImage: `url(${mainBackgroundImg})`,
        backgroundColor: "#7fc7d9", // Average color of the background image.
        backgroundPosition: "center",
      }}
    >
      {/* Increase the network loading priority of the background image. */}
      <img
        style={{ display: "none" }}
        src={mainBackgroundImg}
        alt="increase priority"
      />
      <Typography variant="h2" color="secondary">
        Sua marca em poucos cliques
      </Typography>
      <Typography
        align="center"
        variant="h5"
        sx={{ mb: 4, mt: { xs: 4, sm: 8 }, color: "inherit" }}
      >
        Orçamento antecipado, sem surpresas e com agilidade.
      </Typography>
      <ScheduleNowButton />

      <Box sx={{ position: "absolute", bottom: 30, textAlign: "center" }}>
        <Typography>Saiba mais</Typography>
        <KeyboardDoubleArrowDownIcon />
      </Box>
    </LandingSectionLayout>
  );
}
